import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-203af485"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "account flex-ac"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "欢迎来到德安县总工会", -1));
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  style: {
    "margin-left": "30px"
  }
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"banner\" data-v-203af485><div class=\"logo\" data-v-203af485><div class=\"name\" data-v-203af485><img src=\"" + _imports_0 + "\" alt=\"\" data-v-203af485><div data-v-203af485><p style=\"font-size:40px;letter-spacing:2px;\" data-v-203af485> 德安县总工会</p><p style=\"font-size:11px;text-align:center;\" data-v-203af485>DEAN FEDERATION OF TRADE UNIONS</p></div></div></div></div>", 1);
const _hoisted_8 = {
  class: "menus"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_el_menu = _resolveComponent("el-menu");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _ctx.uid ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.username), 1), _createElementVNode("span", {
    style: {
      "margin-left": "30px"
    },
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.exit && $setup.exit(...args))
  }, "退出")])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", {
    class: "login",
    onClick: _cache[1] || (_cache[1] = $event => $setup.toNav('/register'))
  }, "免费注册"), _createElementVNode("span", {
    class: "regsiter",
    onClick: _cache[2] || (_cache[2] = $event => $setup.toNav('/login'))
  }, "会员登录")]))]), _hoisted_7, _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_menu, {
    "default-active": _ctx.current,
    class: "el-menu-demo fs-20",
    mode: "horizontal",
    "background-color": "#ED0008",
    "text-color": "#fff",
    router: true,
    "active-text-color": "#fff"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item, index) => {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: index
      }, [!item.childlist ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 0,
        index: item.nickname
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
        _: 2
      }, 1032, ["index"])) : (_openBlock(), _createBlock(_component_el_sub_menu, {
        key: 1,
        index: item.nickname
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.childlist, (sitem, sindex) => {
          return _openBlock(), _createBlock(_component_el_menu_item, {
            key: sindex,
            index: sitem.nickname
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(sitem.name), 1)]),
            _: 2
          }, 1032, ["index"]);
        }), 128))]),
        _: 2
      }, 1032, ["index"]))], 64);
    }), 128))]),
    _: 1
  }, 8, ["default-active"])])]);
}